import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import CowDetailPage from './CowDetailPage';
import apiClient from '../utils/apiClient';
import { API_ENDPOINTS, getImageUrl, getApiUrl } from '../config/api';

const TabunganQurban = ({ onBack, selectedTabungan, activeBottomTab, setActiveBottomTab }) => {
  const [userData, setUserData] = useState({
    full_name: 'User',
    email: '',
    id: null
  });

  // State untuk data dari API
  const [loading, setLoading] = useState(true);
  const [tabunganDetail, setTabunganDetail] = useState(null);
  const [produkDetail, setProdukDetail] = useState(null);
  const [timbanganList, setTimbanganList] = useState([]);
  const [vaksinList, setVaksinList] = useState([]);
  const [dokumenList, setDokumenList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [pembayaranList, setPembayaranList] = useState([]);
  const [produkImages, setProdukImages] = useState([]);
  const [timbanganImages, setTimbanganImages] = useState([]);
  const [vaksinImages, setVaksinImages] = useState([]);
  const [pembayaranImages, setPembayaranImages] = useState([]);
  const [dokumenFiles, setDokumenFiles] = useState([]);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [pengirimanList, setPengirimanList] = useState([]);
  const [pengirimanBuktiImages, setPengirimanBuktiImages] = useState([]);
  const [pengirimanResiImages, setPengirimanResiImages] = useState([]);
  const [showCowDetail, setShowCowDetail] = useState(false);
  const [selectedCow, setSelectedCow] = useState(null);
  const [showPaymentProof, setShowPaymentProof] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [pembayaranDetail, setPembayaranDetail] = useState(null);
  const [pembayaranProofImages, setPembayaranProofImages] = useState([]);
  const [loadingPembayaranDetail, setLoadingPembayaranDetail] = useState(false);

  // Fetch user data dari API
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const savedUserData = localStorage.getItem('user_data');
        if (savedUserData) {
          const parsed = JSON.parse(savedUserData);
          if (parsed.id) {
            const response = await apiClient.get(API_ENDPOINTS.USER.GET_BY_ID(parsed.id));
            let userFromApi = null;
            if (response.data && response.data.user) {
              userFromApi = response.data.user;
            } else if (response.data && response.data.data) {
              userFromApi = response.data.data;
            } else if (response.data && !response.data.user) {
              userFromApi = response.data;
            } else if (!response.data) {
              userFromApi = response;
            }
            if (userFromApi) {
              setUserData({
                full_name: userFromApi.full_name || parsed.full_name || 'User',
                email: userFromApi.email || parsed.email || '',
                id: userFromApi.id || parsed.id
              });
            }
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  // Fetch semua data tabungan detail dari API
  useEffect(() => {
    const fetchTabunganDetailData = async () => {
      if (!selectedTabungan || !selectedTabungan.id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const tabunganId = selectedTabungan.id;
        const produkId = selectedTabungan.rawData?.produk_id || selectedTabungan.produkData?.id;

        // Fetch tabungan detail
        try {
          const tabunganResponse = await apiClient.get(API_ENDPOINTS.TABUNGAN.DETAIL(tabunganId));
          let tabungan = null;
          if (tabunganResponse.data && tabunganResponse.data.tabungan) {
            tabungan = tabunganResponse.data.tabungan;
          } else if (tabunganResponse.data && tabunganResponse.data.data) {
            tabungan = tabunganResponse.data.data;
          } else if (tabunganResponse.data && !tabunganResponse.data.tabungan) {
            tabungan = tabunganResponse.data;
          } else if (!tabunganResponse.data) {
            tabungan = tabunganResponse;
          }
          setTabunganDetail(tabungan);
        } catch (error) {
          console.error('Error fetching tabungan detail:', error);
        }

        // Fetch produk detail jika ada produk_id
        if (produkId) {
          try {
            const produkResponse = await apiClient.get(API_ENDPOINTS.PRODUK.DETAIL(produkId));
            let produk = null;
            if (produkResponse.data && produkResponse.data.produk) {
              produk = produkResponse.data.produk;
            } else if (produkResponse.data && produkResponse.data.data) {
              produk = produkResponse.data.data;
            } else if (produkResponse.data && !produkResponse.data.produk) {
              produk = produkResponse.data;
            } else if (!produkResponse.data) {
              produk = produkResponse;
            }
            setProdukDetail(produk);

            // Fetch produk images
            try {
              const imagesResponse = await apiClient.get(API_ENDPOINTS.PRODUK.PUBLIC_IMAGES(produkId));
              let images = [];
              if (imagesResponse.data && Array.isArray(imagesResponse.data)) {
                images = imagesResponse.data;
              } else if (imagesResponse.data && imagesResponse.data.images && Array.isArray(imagesResponse.data.images)) {
                images = imagesResponse.data.images;
              }
              setProdukImages(images);
            } catch (error) {
              console.error('Error fetching produk images:', error);
            }

            // Fetch timbangan produk
            try {
              const timbanganResponse = await apiClient.get(API_ENDPOINTS.TIMBANGAN_PRODUK.BY_PRODUK(produkId));
              let timbangan = [];
              if (timbanganResponse.data && Array.isArray(timbanganResponse.data)) {
                timbangan = timbanganResponse.data;
              } else if (timbanganResponse.data && timbanganResponse.data.timbangan_produk && Array.isArray(timbanganResponse.data.timbangan_produk)) {
                timbangan = timbanganResponse.data.timbangan_produk;
              } else if (timbanganResponse.data && timbanganResponse.data.data && Array.isArray(timbanganResponse.data.data)) {
                timbangan = timbanganResponse.data.data;
              }
              setTimbanganList(timbangan);

              // Fetch timbangan images untuk setiap timbangan
              if (timbangan.length > 0) {
                const timbanganImagesPromises = timbangan.map(async (timbanganItem) => {
                  try {
                    const imagesResponse = await apiClient.get(API_ENDPOINTS.TIMBANGAN_PRODUK.IMAGES(produkId));
                    let images = [];
                    if (imagesResponse.data && Array.isArray(imagesResponse.data)) {
                      images = imagesResponse.data;
                    } else if (imagesResponse.data && imagesResponse.data.images && Array.isArray(imagesResponse.data.images)) {
                      images = imagesResponse.data.images;
                    }
                    return images;
                  } catch (error) {
                    console.error(`Error fetching timbangan images for ${produkId}:`, error);
                    return [];
                  }
                });
                const allTimbanganImages = await Promise.all(timbanganImagesPromises);
                setTimbanganImages(allTimbanganImages.flat());
              }
            } catch (error) {
              console.error('Error fetching timbangan produk:', error);
            }

            // Fetch vaksin produk
            try {
              const vaksinResponse = await apiClient.get(API_ENDPOINTS.VAKSIN_PRODUK.BY_PRODUK(produkId));
              let vaksin = [];
              if (vaksinResponse.data && Array.isArray(vaksinResponse.data)) {
                vaksin = vaksinResponse.data;
              } else if (vaksinResponse.data && vaksinResponse.data.vaksin_produk && Array.isArray(vaksinResponse.data.vaksin_produk)) {
                vaksin = vaksinResponse.data.vaksin_produk;
              } else if (vaksinResponse.data && vaksinResponse.data.data && Array.isArray(vaksinResponse.data.data)) {
                vaksin = vaksinResponse.data.data;
              }
              setVaksinList(vaksin);

              // Fetch vaksin images untuk setiap vaksin
              if (vaksin.length > 0) {
                const vaksinImagesPromises = vaksin.map(async (vaksinItem) => {
                  if (vaksinItem.id) {
                    try {
                      const imagesResponse = await apiClient.get(API_ENDPOINTS.VAKSIN_PRODUK.IMAGES(vaksinItem.id));
                      let images = [];
                      if (imagesResponse.data && Array.isArray(imagesResponse.data)) {
                        images = imagesResponse.data;
                      } else if (imagesResponse.data && imagesResponse.data.images && Array.isArray(imagesResponse.data.images)) {
                        images = imagesResponse.data.images;
                      }
                      return images;
                    } catch (error) {
                      console.error(`Error fetching vaksin images for ${vaksinItem.id}:`, error);
                      return [];
                    }
                  }
                  return [];
                });
                const allVaksinImages = await Promise.all(vaksinImagesPromises);
                setVaksinImages(allVaksinImages.flat());
              }
            } catch (error) {
              console.error('Error fetching vaksin produk:', error);
            }
          } catch (error) {
            console.error('Error fetching produk detail:', error);
          }
        }

        // Fetch dokumen
        try {
          const dokumenResponse = await apiClient.get(API_ENDPOINTS.DOKUMEN.BY_TABUNGAN(tabunganId));
          let dokumen = [];
          if (dokumenResponse.data && Array.isArray(dokumenResponse.data)) {
            dokumen = dokumenResponse.data;
          } else if (dokumenResponse.data && dokumenResponse.data.dokumen && Array.isArray(dokumenResponse.data.dokumen)) {
            dokumen = dokumenResponse.data.dokumen;
          } else if (dokumenResponse.data && dokumenResponse.data.data && Array.isArray(dokumenResponse.data.data)) {
            dokumen = dokumenResponse.data.data;
          }
          setDokumenList(dokumen);

          // Fetch dokumen files
          if (tabunganId) {
            try {
              const filesResponse = await apiClient.get(API_ENDPOINTS.DOKUMEN.FILES(tabunganId));
              let files = [];
              
              // Handle struktur response sesuai dengan API yang diberikan
              // apiClient.get() mengembalikan JSON langsung dari handleResponse
              // Response structure dari API: { status: 200, message: "...", data: { entity_id: "...", documents: [...], total_documents: 1 } }
              // Jadi filesResponse langsung = { status: 200, message: "...", data: { ... } }
              
              // Case 1: filesResponse.data.documents (struktur utama dari API yang diberikan)
              if (filesResponse.data && filesResponse.data.documents && Array.isArray(filesResponse.data.documents)) {
                files = filesResponse.data.documents;
              }
              // Case 2: filesResponse.data.data.documents (jika ada double wrap)
              else if (filesResponse.data && filesResponse.data.data && filesResponse.data.data.documents && Array.isArray(filesResponse.data.data.documents)) {
                files = filesResponse.data.data.documents;
              }
              // Case 3: filesResponse.documents (jika response langsung)
              else if (filesResponse.documents && Array.isArray(filesResponse.documents)) {
                files = filesResponse.documents;
              }
              // Case 4: filesResponse.data.data adalah array
              else if (filesResponse.data && filesResponse.data.data && Array.isArray(filesResponse.data.data)) {
                files = filesResponse.data.data;
              }
              // Case 5: filesResponse.data langsung array
              else if (filesResponse.data && Array.isArray(filesResponse.data)) {
                files = filesResponse.data;
              }
              // Case 6: filesResponse.data.files
              else if (filesResponse.data && filesResponse.data.files && Array.isArray(filesResponse.data.files)) {
                files = filesResponse.data.files;
              }
              
              setDokumenFiles(files);
            } catch (error) {
              console.error('Error fetching dokumen files:', error);
              setDokumenFiles([]);
            }
          }
        } catch (error) {
          console.error('Error fetching dokumen:', error);
        }

        // Fetch invoice
        try {
          const invoiceResponse = await apiClient.get(API_ENDPOINTS.INVOICE.BY_TABUNGAN(tabunganId));
          let invoice = [];
          if (invoiceResponse.data && Array.isArray(invoiceResponse.data)) {
            invoice = invoiceResponse.data;
          } else if (invoiceResponse.data && invoiceResponse.data.invoice && Array.isArray(invoiceResponse.data.invoice)) {
            invoice = invoiceResponse.data.invoice;
          } else if (invoiceResponse.data && invoiceResponse.data.data && Array.isArray(invoiceResponse.data.data)) {
            invoice = invoiceResponse.data.data;
          }
          setInvoiceList(invoice);

          // Fetch invoice files
          if (tabunganId) {
            try {
              const filesResponse = await apiClient.get(API_ENDPOINTS.INVOICE.FILES(tabunganId));
              let files = [];
              
              // Handle struktur response sesuai dengan API (sama seperti dokumen files)
              // Response structure: { status: 200, message: "...", data: { entity_id: "...", documents: [...], total_documents: 1 } }
              
              // Case 1: filesResponse.data.documents (struktur utama)
              if (filesResponse.data && filesResponse.data.documents && Array.isArray(filesResponse.data.documents)) {
                files = filesResponse.data.documents;
              }
              // Case 2: filesResponse.data.data.documents (jika ada double wrap)
              else if (filesResponse.data && filesResponse.data.data && filesResponse.data.data.documents && Array.isArray(filesResponse.data.data.documents)) {
                files = filesResponse.data.data.documents;
              }
              // Case 3: filesResponse.documents (jika response langsung)
              else if (filesResponse.documents && Array.isArray(filesResponse.documents)) {
                files = filesResponse.documents;
              }
              // Case 4: filesResponse.data.data adalah array
              else if (filesResponse.data && filesResponse.data.data && Array.isArray(filesResponse.data.data)) {
                files = filesResponse.data.data;
              }
              // Case 5: filesResponse.data langsung array
              else if (filesResponse.data && Array.isArray(filesResponse.data)) {
                files = filesResponse.data;
              }
              // Case 6: filesResponse.data.files
              else if (filesResponse.data && filesResponse.data.files && Array.isArray(filesResponse.data.files)) {
                files = filesResponse.data.files;
              }
              
              setInvoiceFiles(files);
            } catch (error) {
              console.error('Error fetching invoice files:', error);
              setInvoiceFiles([]);
            }
          }
        } catch (error) {
          console.error('Error fetching invoice:', error);
        }

        // Fetch pembayaran
        try {
          const pembayaranResponse = await apiClient.get(API_ENDPOINTS.PEMBAYARAN.BY_TABUNGAN(tabunganId));
          let pembayaran = [];
          if (pembayaranResponse.data && Array.isArray(pembayaranResponse.data)) {
            pembayaran = pembayaranResponse.data;
          } else if (pembayaranResponse.data && pembayaranResponse.data.pembayarans && Array.isArray(pembayaranResponse.data.pembayarans)) {
            pembayaran = pembayaranResponse.data.pembayarans;
          } else if (pembayaranResponse.data && pembayaranResponse.data.data && Array.isArray(pembayaranResponse.data.data)) {
            pembayaran = pembayaranResponse.data.data;
          }
          setPembayaranList(pembayaran);

          // Fetch pembayaran images
          if (tabunganId) {
            try {
              const imagesResponse = await apiClient.get(API_ENDPOINTS.PEMBAYARAN.IMAGES(tabunganId));
              let images = [];
              if (imagesResponse.data && Array.isArray(imagesResponse.data)) {
                images = imagesResponse.data;
              } else if (imagesResponse.data && imagesResponse.data.images && Array.isArray(imagesResponse.data.images)) {
                images = imagesResponse.data.images;
              }
              setPembayaranImages(images);
            } catch (error) {
              console.error('Error fetching pembayaran images:', error);
            }
          }
        } catch (error) {
          console.error('Error fetching pembayaran:', error);
        }

        // Fetch pengiriman
        try {
          const pengirimanResponse = await apiClient.get(API_ENDPOINTS.PENGIRIMAN.BY_TABUNGAN(tabunganId));
          let pengiriman = [];
          if (pengirimanResponse.data && Array.isArray(pengirimanResponse.data)) {
            pengiriman = pengirimanResponse.data;
          } else if (pengirimanResponse.data && pengirimanResponse.data.pengiriman && Array.isArray(pengirimanResponse.data.pengiriman)) {
            pengiriman = pengirimanResponse.data.pengiriman;
          } else if (pengirimanResponse.data && pengirimanResponse.data.pengirimans && Array.isArray(pengirimanResponse.data.pengirimans)) {
            pengiriman = pengirimanResponse.data.pengirimans;
          } else if (pengirimanResponse.data && pengirimanResponse.data.data && Array.isArray(pengirimanResponse.data.data)) {
            pengiriman = pengirimanResponse.data.data;
          }
          setPengirimanList(pengiriman);

          // Fetch pengiriman images (bukti dan resi)
          if (tabunganId) {
            try {
              const buktiResponse = await apiClient.get(API_ENDPOINTS.PENGIRIMAN.BUKTI_IMAGES(tabunganId));
              let buktiImages = [];
              if (buktiResponse.data && Array.isArray(buktiResponse.data)) {
                buktiImages = buktiResponse.data;
              } else if (buktiResponse.data && buktiResponse.data.images && Array.isArray(buktiResponse.data.images)) {
                buktiImages = buktiResponse.data.images;
              }
              setPengirimanBuktiImages(buktiImages);

              const resiResponse = await apiClient.get(API_ENDPOINTS.PENGIRIMAN.RESI_IMAGES(tabunganId));
              let resiImages = [];
              if (resiResponse.data && Array.isArray(resiResponse.data)) {
                resiImages = resiResponse.data;
              } else if (resiResponse.data && resiResponse.data.images && Array.isArray(resiResponse.data.images)) {
                resiImages = resiResponse.data.images;
              }
              setPengirimanResiImages(resiImages);
            } catch (error) {
              console.error('Error fetching pengiriman images:', error);
            }
          }
        } catch (error) {
          console.error('Error fetching pengiriman:', error);
          setPengirimanList([]);
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching tabungan detail data:', error);
        setLoading(false);
      }
    };

    fetchTabunganDetailData();
  }, [selectedTabungan]);

  // Fetch pembayaran detail ketika selectedPayment berubah
  useEffect(() => {
    const fetchPembayaranDetail = async () => {
      if (!selectedPayment || !selectedPayment.id) {
        setPembayaranDetail(null);
        setPembayaranProofImages([]);
        setLoadingPembayaranDetail(false);
        return;
      }

      try {
        setLoadingPembayaranDetail(true);
        // Gunakan rawData.id jika ada, atau selectedPayment.id
        const pembayaranId = selectedPayment.rawData?.id || selectedPayment.id;

        // Fetch pembayaran detail
        try {
          const pembayaranResponse = await apiClient.get(API_ENDPOINTS.PEMBAYARAN.DETAIL(pembayaranId));
          let pembayaran = null;
          if (pembayaranResponse.data && pembayaranResponse.data.pembayaran) {
            pembayaran = pembayaranResponse.data.pembayaran;
          } else if (pembayaranResponse.data && pembayaranResponse.data.data) {
            pembayaran = pembayaranResponse.data.data;
          } else if (pembayaranResponse.data && !pembayaranResponse.data.pembayaran) {
            pembayaran = pembayaranResponse.data;
          } else if (!pembayaranResponse.data) {
            pembayaran = pembayaranResponse;
          }
          setPembayaranDetail(pembayaran);

          // Fetch pembayaran images menggunakan pembayaran_id
          if (pembayaranId) {
            try {
              const imagesResponse = await apiClient.get(API_ENDPOINTS.PEMBAYARAN.IMAGES(pembayaranId));
              let images = [];
              if (imagesResponse.data && Array.isArray(imagesResponse.data)) {
                images = imagesResponse.data;
              } else if (imagesResponse.data && imagesResponse.data.images && Array.isArray(imagesResponse.data.images)) {
                images = imagesResponse.data.images;
              }
              setPembayaranProofImages(images);
            } catch (error) {
              console.error('Error fetching pembayaran images:', error);
              setPembayaranProofImages([]);
            }
          }
        } catch (error) {
          console.error('Error fetching pembayaran detail:', error);
          setPembayaranDetail(null);
        }

        setLoadingPembayaranDetail(false);
      } catch (error) {
        console.error('Error in fetchPembayaranDetail:', error);
        setLoadingPembayaranDetail(false);
      }
    };

    fetchPembayaranDetail();
  }, [selectedPayment, selectedTabungan]);

  // Format currency helper
  const formatCurrency = (value) => {
    if (!value) return 'Rp 0';
    const numValue = typeof value === 'number' ? value : parseFloat(value) || 0;
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(numValue);
  };

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                     'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Format bulan tahun helper
  const formatBulanTahun = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                     'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Get status pembayaran text
  const getStatusText = (status) => {
    if (!status) return 'Lunas';
    const statusLower = status.toLowerCase();
    if (statusLower.includes('lunas') || statusLower.includes('verif') || statusLower.includes('diterima') || statusLower.includes('approved')) {
      return 'Lunas';
    }
    return status;
  };

  // Get image URL helper untuk produk images
  const getProdukImageUrl = (images) => {
    if (images && Array.isArray(images) && images.length > 0) {
      const firstImage = images[0];
      if (typeof firstImage === 'string') {
        return getImageUrl(firstImage);
      } else if (firstImage.url) {
        return getImageUrl(firstImage.url);
      } else if (firstImage.filename) {
        const produkId = produkDetail?.id || selectedTabungan?.rawData?.produk_id || '';
        return getImageUrl(`/images/produk/${produkId}/${firstImage.filename}`);
      }
    }
    return '/sapi1.jpg'; // Fallback image
  };

  // Download file dokumen
  const downloadDokumenFile = async (file) => {
    if (!selectedTabungan?.id) return;
    
    try {
      const tabunganId = selectedTabungan.id;
      // Handle file bisa berupa string (filename) atau object
      const filename = typeof file === 'string' ? file : (file.filename || file.name || '');
      const fileUrl = typeof file === 'object' && file.url 
        ? getApiUrl(file.url)
        : getApiUrl(`/documents/dokumen/${tabunganId}/${filename}`);
      
      // Buat link untuk download
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading dokumen file:', error);
      alert('Gagal mengunduh file dokumen');
    }
  };

  // Download file invoice
  const downloadInvoiceFile = async (file) => {
    if (!selectedTabungan?.id) return;
    
    try {
      const tabunganId = selectedTabungan.id;
      // Handle file bisa berupa string (filename) atau object
      const filename = typeof file === 'string' ? file : (file.filename || file.name || '');
      const fileUrl = typeof file === 'object' && file.url 
        ? getApiUrl(file.url)
        : getApiUrl(`/documents/invoice/${tabunganId}/${filename}`);
      
      // Buat link untuk download
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading invoice file:', error);
      alert('Gagal mengunduh file invoice');
    }
  };

  // Format file size helper
  const formatFileSize = (bytes) => {
    if (!bytes) return '0 KB';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} KB`;
    const mb = kb / 1024;
    return `${mb.toFixed(2)} MB`;
  };

  // Data summary tabungan - gunakan data dari selectedTabungan jika ada
  const summaryData = selectedTabungan ? {
    jumlahTabungan: selectedTabungan.jumlah,
    totalTabungan: selectedTabungan.nilai
  } : {
    jumlahTabungan: '1 Ekor',
    totalTabungan: 'Rp 3.600.000'
  };

  // Data tabungan - ambil dari produkDetail yang sudah di-fetch dari API
  const getTabunganData = () => {
    // Jika produkDetail sudah di-fetch, gunakan data dari API
    if (produkDetail) {
      const namaProduk = produkDetail.nama || produkDetail.name || 'Produk';
      const targetBobot = produkDetail.target_bobot || 0;
      const bobotText = targetBobot > 0 ? `${targetBobot} Kg` : '-';
      const hargaBeli = produkDetail.harga_beli || produkDetail.price || produkDetail.harga || 0;
      const hargaText = formatCurrency(hargaBeli);
      
      // Ambil tanggal dari tabungan atau produk
      const tanggal = tabunganDetail?.created_at 
        ? new Date(tabunganDetail.created_at).toLocaleDateString('id-ID', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })
        : produkDetail.created_at
        ? new Date(produkDetail.created_at).toLocaleDateString('id-ID', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })
        : '';

      // Ambil image dari produkImages
      const imageUrl = getProdukImageUrl(produkImages);

      // Ambil kategori/jenis produk
      const kategori = produkDetail.kategori_produk?.nama || produkDetail.kategori || '';
      const jenisProduk = produkDetail.jenis_produk?.nama || produkDetail.jenis_produk_detail?.nama || '';
      const breed = jenisProduk || kategori || namaProduk;

      return [
        {
          id: produkDetail.id || 'PR001',
          name: namaProduk,
          weight: bobotText,
          price: hargaText,
          date: tanggal,
          status: selectedTabungan?.status?.toLowerCase() || 'aktif',
          image: imageUrl,
          breed: breed,
          code: `${produkDetail.id || 'PR001'} ${new Date().getFullYear()} / ${tanggal}`,
          productType: jenisProduk || kategori || namaProduk,
          targetWeight: bobotText,
          category: kategori || 'Standard',
          purchasePrice: hargaText,
          sellingPrice: formatCurrency(produkDetail.harga_jual || produkDetail.selling_price || hargaBeli),
          marketingFee: formatCurrency(produkDetail.fee_marketing || 0),
          profitBersama: formatCurrency(0),
          profit30: formatCurrency(0),
          isSold: produkDetail.is_sold || false,
          rawProdukData: produkDetail
        }
      ];
    }
    
    // Fallback ke data default jika produkDetail belum di-fetch
    if (selectedTabungan?.type === 'Tabungan Aqiqah') {
      return [
        {
          id: 'ETW001',
          name: 'Kambing Etawa 35kg',
          weight: '35 Kg',
          price: 'Rp 4.500.000',
          date: '10 Agustus 2025',
          status: 'selesai',
          image: '/sapi2.jpg',
          breed: 'Kambing Etawa',
          code: 'ETW001 2025 / 10 Agustus 2025',
          productType: 'Kambing Etawa',
          targetWeight: '35 Kg',
          category: 'Premium',
          purchasePrice: 'Rp 4.500.000',
          sellingPrice: 'Rp 4.500.000',
          marketingFee: 'Rp 0',
          profitBersama: 'Rp 0',
          profit30: 'Rp 0'
        }
      ];
    }
    
    // Default untuk Tabungan Qurban
    return [
      {
        id: 'AFR001',
        name: 'Afri Domba 40kg',
        weight: '40 Kg',
        price: 'Rp 3.600.000',
        date: '17 September 2025',
        status: 'aktif',
        image: '/sapi1.jpg',
        breed: 'Domba Afri',
        code: 'AFR001 2025 / 17 September 2025',
        productType: 'Domba Afri',
        targetWeight: '40 Kg',
        category: 'Ekonomis',
        purchasePrice: 'Rp 3.600.000',
        sellingPrice: 'Rp 3.600.000',
        marketingFee: 'Rp 0',
        profitBersama: 'Rp 0',
        profit30: 'Rp 0'
      }
    ];
  };

  const tabunganData = getTabunganData();

  // Jika sedang menampilkan detail sapi
  if (showCowDetail && selectedCow) {
    return (
      <CowDetailPage 
        cowData={selectedCow}
        onBack={() => setShowCowDetail(false)}
        activeBottomTab={activeBottomTab}
        setActiveBottomTab={setActiveBottomTab}
      />
    );
  }

  // Jika sedang menampilkan bukti pembayaran
  if (showPaymentProof && selectedPayment) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
          {/* Header */}
          <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <button 
                  onClick={() => setShowPaymentProof(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
                </button>
                <h1 className="text-xl font-bold text-primary">Bukti Pembayaran</h1>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="pb-8 bg-gray-50">
            <section className="px-4 pt-6">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-primary p-3">
                  <h4 className="text-white font-bold text-center">Bukti Transfer</h4>
                </div>
                <div className="p-6">
                  {loadingPembayaranDetail ? (
                    <div className="space-y-4">
                      <div className="h-48 bg-gray-100 rounded animate-pulse"></div>
                      <div className="h-64 bg-gray-100 rounded animate-pulse"></div>
                    </div>
                  ) : pembayaranDetail ? (
                    <>
                      {/* Transfer Info */}
                      <div className="text-center mb-6">
                        <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                          <i className="fa-solid fa-receipt text-3xl text-primary"></i>
                        </div>
                        <h3 className="text-xl font-bold text-primary mb-2">
                          {formatBulanTahun(pembayaranDetail.created_at || pembayaranDetail.tanggal || selectedPayment.tanggal)}
                        </h3>
                        <p className="text-2xl font-bold text-secondary">
                          {formatCurrency(pembayaranDetail.nominal || pembayaranDetail.jumlah || selectedPayment.jumlah)}
                        </p>
                        <p className="text-sm text-gray-500 mt-1">
                          {formatDate(pembayaranDetail.created_at || pembayaranDetail.tanggal || selectedPayment.tanggal)}
                        </p>
                      </div>

                      {/* Transfer Details */}
                      <div className="space-y-4">
                        <div className="bg-gray-50 rounded-xl p-4">
                          <h5 className="font-semibold text-gray-700 mb-3">Detail Transfer</h5>
                          <div className="space-y-2">
                            <div className="flex justify-between">
                              <span className="text-sm text-gray-600">Bank Pengirim</span>
                              <span className="text-sm font-semibold">
                                {pembayaranDetail.bank_name || 'Bank BCA'}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-sm text-gray-600">No. Rekening</span>
                              <span className="text-sm font-semibold">
                                {pembayaranDetail.rek_no ? `****${pembayaranDetail.rek_no.slice(-4)}` : '****1234'}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-sm text-gray-600">Nama Pengirim</span>
                              <span className="text-sm font-semibold">{userData.full_name || 'User'}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-sm text-gray-600">Waktu Transfer</span>
                              <span className="text-sm font-semibold">
                                {pembayaranDetail.created_at 
                                  ? new Date(pembayaranDetail.created_at).toLocaleTimeString('id-ID', { 
                                      hour: '2-digit', 
                                      minute: '2-digit',
                                      timeZone: 'Asia/Jakarta'
                                    }) + ' WIB'
                                  : '14:30 WIB'}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-sm text-gray-600">Status</span>
                              <span className={`text-xs px-2 py-1 rounded-full font-semibold ${
                                pembayaranDetail.status?.toLowerCase() === 'approved' || 
                                pembayaranDetail.status?.toLowerCase() === 'diterima' ||
                                pembayaranDetail.status?.toLowerCase() === 'berhasil' ||
                                pembayaranDetail.status?.toLowerCase() === 'lunas'
                                  ? 'bg-green-100 text-green-600'
                                  : pembayaranDetail.status?.toLowerCase() === 'pending' ||
                                    pembayaranDetail.status?.toLowerCase() === 'menunggu'
                                  ? 'bg-yellow-100 text-yellow-600'
                                  : 'bg-red-100 text-red-600'
                              }`}>
                                {pembayaranDetail.status || 'Berhasil'}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Bank Receipt Image */}
                        <div className="bg-gray-50 rounded-xl p-4">
                          <h5 className="font-semibold text-gray-700 mb-3">Bukti Transfer</h5>
                          {pembayaranProofImages && pembayaranProofImages.length > 0 ? (
                            <div className="space-y-3">
                              {pembayaranProofImages.map((image, index) => {
                                const imageUrl = typeof image === 'string' 
                                  ? getImageUrl(image)
                                  : getImageUrl(image.url || image.filename || '');
                                const filename = typeof image === 'string'
                                  ? image.split('/').pop()
                                  : (image.filename || image.name || `bukti_transfer_${index + 1}.jpg`);
                                
                                return (
                                  <div key={index} className="bg-white rounded-lg border-2 border-dashed border-gray-300 p-6 text-center">
                                    <img 
                                      src={imageUrl} 
                                      alt={`Bukti transfer ${index + 1}`}
                                      className="w-full h-auto rounded-lg mb-3 max-h-64 object-contain mx-auto"
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                      }}
                                    />
                                    <div className="hidden flex-col items-center justify-center">
                                      <i className="fa-solid fa-image text-4xl text-gray-400 mb-3"></i>
                                      <p className="text-sm text-gray-600 mb-3">Foto Bukti Transfer</p>
                                    </div>
                                    <div className="bg-gray-100 rounded-lg p-4 mb-3">
                                      <p className="text-xs text-gray-500 truncate">{filename}</p>
                                    </div>
                                    <button 
                                      onClick={() => {
                                        window.open(imageUrl, '_blank');
                                      }}
                                      className="bg-secondary hover:bg-primary text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
                                    >
                                      <i className="fa-solid fa-eye mr-2"></i>
                                      Lihat Gambar
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="bg-white rounded-lg border-2 border-dashed border-gray-300 p-6 text-center">
                              <i className="fa-solid fa-image text-4xl text-gray-400 mb-3"></i>
                              <p className="text-sm text-gray-600 mb-3">Foto Bukti Transfer</p>
                              <div className="bg-gray-100 rounded-lg p-4 mb-3">
                                <p className="text-xs text-gray-500">Belum ada gambar bukti transfer</p>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Reference Number */}
                        <div className="bg-primary rounded-xl p-4 text-center">
                          <p className="text-white text-sm mb-1">Nomor Referensi</p>
                          <p className="text-accent font-bold text-lg">
                            {pembayaranDetail.id || selectedPayment.id || '-'}
                          </p>
                        </div>

                        {/* Deskripsi jika ada */}
                        {pembayaranDetail.deskripsi && (
                          <div className="bg-gray-50 rounded-xl p-4">
                            <h5 className="font-semibold text-gray-700 mb-2">Deskripsi</h5>
                            <p className="text-sm text-gray-600">{pembayaranDetail.deskripsi}</p>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-8">
                      <i className="fa-solid fa-exclamation-circle text-4xl text-gray-300 mb-3"></i>
                      <p className="text-gray-500 text-sm">Data pembayaran tidak ditemukan</p>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary text-lg">
                  {selectedTabungan ? selectedTabungan.type : 'Detail Tabungan'}
                </span>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-24 bg-gray-50">
          {/* Summary Cards */}
          <section className="px-4 pt-6">
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white rounded-2xl shadow-lg p-4 text-center">
                <div className="bg-secondary p-2 rounded-lg w-fit mx-auto mb-2">
                  <i className="fa-solid fa-leaf text-accent text-lg"></i>
                </div>
                <h4 className="text-gray-600 text-xs font-medium">Jumlah Tabungan</h4>
                <p className="text-xl font-bold text-primary mt-1">{summaryData.jumlahTabungan}</p>
              </div>

              <div className="bg-white rounded-2xl shadow-lg p-4 text-center">
                <div className="bg-secondary p-2 rounded-lg w-fit mx-auto mb-2">
                  <i className="fa-solid fa-leaf text-accent text-lg"></i>
                </div>
                <h4 className="text-gray-600 text-xs font-medium">Total Tabungan</h4>
                <p className="text-xl font-bold text-primary mt-1">{summaryData.totalTabungan}</p>
              </div>
            </div>
          </section>

          {/* Data Tabungan */}
          <section className="px-4 mb-6">
            <h3 className="text-gray-700 font-semibold mb-4">Data Tabungan</h3>
            
            {loading ? (
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden animate-pulse">
                <div className="p-4">
                  <div className="flex items-center space-x-4">
                    <div className="w-20 h-20 bg-gray-200 rounded-xl"></div>
                    <div className="flex-1 space-y-2">
                      <div className="h-5 bg-gray-200 rounded w-3/4"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                      <div className="h-5 bg-gray-200 rounded w-1/3"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>
                </div>
                <div className="px-4 pb-4">
                  <div className="w-full h-12 bg-gray-200 rounded-xl"></div>
                </div>
              </div>
            ) : (
              <div className="space-y-4">
                {tabunganData.map((item, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="p-4">
                    <div className="flex items-center space-x-4">
                      {/* Image placeholder */}
                      <div className="w-20 h-20 bg-gray-100 rounded-xl flex items-center justify-center">
                        <img 
                          src={item.image} 
                          alt={item.name}
                          className="w-full h-full object-cover rounded-xl"
                        />
                      </div>
                      
                      {/* Content */}
                      <div className="flex-1">
                        <h4 className="text-primary font-bold text-lg">{item.name}</h4>
                        <p className="text-gray-600 text-sm">{item.weight}</p>
                        <p className="text-primary font-bold text-lg mt-1">{item.price}</p>
                        <p className="text-gray-500 text-xs">{item.date}</p>
                        {item.isSold && (
                          <div className="mt-2">
                            <span className="bg-red-100 text-red-600 px-2 py-1 rounded-full text-xs font-semibold">
                              <i className="fa-solid fa-check-circle mr-1"></i>
                              Terjual
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  {/* Action Button */}
                  <div className="px-4 pb-4">
                    <button 
                      onClick={() => {
                        setSelectedCow(item);
                        setShowCowDetail(true);
                      }}
                      className="w-full bg-accent text-primary font-semibold py-3 px-4 rounded-xl flex items-center justify-center space-x-2 hover:bg-accent/90 transition-colors"
                    >
                      <i className="fa-solid fa-info-circle"></i>
                      <span>Detail Sapi</span>
                    </button>
                  </div>
                </div>
                ))}
              </div>
            )}
          </section>

          {/* Dokumen Perjanjian */}
          <section className="px-4">
            <h3 className="text-gray-700 font-semibold mb-4">Dokumen Perjanjian</h3>
            
            {/* File Dokumen Section */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="bg-secondary p-3">
                <h4 className="text-white font-bold text-center">File Dokumen</h4>
              </div>
              <div className="p-4">
                {loading ? (
                  <div className="space-y-3">
                    <div className="bg-gray-100 rounded-xl p-4 animate-pulse">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>
                ) : dokumenFiles && dokumenFiles.length > 0 ? (
                  <div className="space-y-3">
                    {dokumenFiles.map((file, index) => {
                      const filename = typeof file === 'string' ? file : (file.filename || file.name || `Dokumen ${index + 1}`);
                      const fileSize = typeof file === 'object' && file.file_size ? formatFileSize(file.file_size) : (file.size ? formatFileSize(file.size) : '');
                      const fileType = filename.split('.').pop()?.toUpperCase() || 'FILE';
                      const isPdf = fileType === 'PDF';
                      const fileUrl = typeof file === 'object' && file.url ? file.url : null;
                      
                      return (
                        <div key={index} className="bg-gray-50 rounded-xl p-4">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3 flex-1">
                              <div className={`${isPdf ? 'bg-red-500' : 'bg-blue-500'} p-3 rounded-lg`}>
                                <i className={`fa-solid ${isPdf ? 'fa-file-pdf' : 'fa-file'} text-white text-xl`}></i>
                              </div>
                              <div className="flex-1 min-w-0">
                                <h6 className="font-semibold text-gray-800 text-sm truncate">{filename}</h6>
                                {fileSize && (
                                  <p className="text-xs text-gray-500 mt-1">{fileSize}</p>
                                )}
                                <p className="text-xs text-gray-400 mt-1">{fileType} Document</p>
                              </div>
                            </div>
                            <button
                              onClick={() => downloadDokumenFile(file)}
                              className="bg-secondary hover:bg-primary text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors flex items-center space-x-2 ml-3"
                            >
                              <i className="fa-solid fa-download"></i>
                              <span>Download</span>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="bg-gray-50 rounded-xl p-6 text-center">
                    <i className="fa-solid fa-file-circle-question text-4xl text-gray-300 mb-3"></i>
                    <p className="text-gray-500 text-sm">Belum ada dokumen</p>
                  </div>
                )}
              </div>
            </div>

            {/* Detail Dokumen Section */}
            {dokumenList && dokumenList.length > 0 && (
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden mt-4">
                <div className="bg-accent p-3">
                  <h4 className="text-primary font-bold text-center text-white">Detail Dokumen</h4>
                </div>
                <div className="p-4">
                  {dokumenList.map((dokumen, index) => {
                    const namaDokumen = dokumen.deskripsi || `Dokumen ${index + 1}`;
                    const tanggalDokumen = dokumen.created_at 
                      ? new Date(dokumen.created_at).toLocaleDateString('id-ID', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })
                      : tabunganData[0]?.date || '';

                    return (
                      <div key={index} className={index > 0 ? 'mt-4 pt-4 border-t border-gray-100' : ''}>
                        <div className="space-y-3">
                          <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-gray-600 text-sm">Nama Dokumen</span>
                            <span className="text-primary font-semibold text-sm text-right">{namaDokumen}</span>
                          </div>
                          <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-gray-600 text-sm">Nama Customer</span>
                            <span className="text-primary font-semibold text-sm">{userData.full_name}</span>
                          </div>
                          <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-gray-600 text-sm">Kategori</span>
                            <span className="text-primary font-semibold text-sm">Tabungan</span>
                          </div>
                          <div className="flex justify-between items-center py-2">
                            <span className="text-gray-600 text-sm">Tanggal Dokumen</span>
                            <span className="text-primary font-semibold text-sm">{tanggalDokumen}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Deskripsi Section */}
            {dokumenList && dokumenList.length > 0 && dokumenList[0]?.deskripsi && (
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden mt-4">
                <div className="bg-accent p-3">
                  <h4 className="text-primary font-bold text-center text-white">Deskripsi</h4>
                </div>
                <div className="p-4">
                  <p className="text-gray-700 text-sm">{dokumenList[0].deskripsi}</p>
                </div>
              </div>
            )}

            {/* Invoice PDF Section */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden mt-4">
              <div className="bg-accent p-3">
                <h4 className="text-primary font-bold text-center text-white">Invoice Tabungan</h4>
              </div>
              <div className="p-4">
                {loading ? (
                  <div className="space-y-3">
                    <div className="bg-gray-100 rounded-xl p-4 animate-pulse">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>
                ) : invoiceFiles && invoiceFiles.length > 0 ? (
                  <div className="space-y-3">
                    {invoiceFiles.map((file, index) => {
                      const filename = typeof file === 'string' ? file : (file.filename || file.name || `Invoice ${index + 1}`);
                      const fileSize = typeof file === 'object' && file.file_size ? formatFileSize(file.file_size) : (file.size ? formatFileSize(file.size) : '');
                      const fileType = filename.split('.').pop()?.toUpperCase() || 'FILE';
                      const isPdf = fileType === 'PDF';
                      const fileUrl = typeof file === 'object' && file.url ? file.url : null;
                      
                      return (
                        <div key={index} className="bg-gray-50 rounded-xl p-4">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3 flex-1">
                              <div className={`${isPdf ? 'bg-red-500' : 'bg-blue-500'} p-3 rounded-lg`}>
                                <i className={`fa-solid ${isPdf ? 'fa-file-pdf' : 'fa-file'} text-white text-xl`}></i>
                              </div>
                              <div className="flex-1 min-w-0">
                                <h6 className="font-semibold text-gray-800 text-sm truncate">{filename}</h6>
                                {fileSize && (
                                  <p className="text-xs text-gray-500 mt-1">{fileSize}</p>
                                )}
                                <p className="text-xs text-gray-400 mt-1">{fileType} Document</p>
                              </div>
                            </div>
                            <button
                              onClick={() => downloadInvoiceFile(file)}
                              className="bg-accent hover:bg-accent/90 text-primary font-semibold px-4 py-2 rounded-lg text-sm transition-colors flex items-center space-x-2 ml-3"
                            >
                              <i className="fa-solid fa-download"></i>
                              <span>Download</span>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="bg-gray-50 rounded-xl p-6 text-center">
                    <i className="fa-solid fa-file-circle-question text-4xl text-gray-300 mb-3"></i>
                    <p className="text-gray-500 text-sm">Belum ada invoice</p>
                  </div>
                )}
              </div>
            </div>

            {/* Pembayaran Section */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden mt-4">
              <div className="bg-secondary p-3">
                <h4 className="text-white font-bold text-center">Riwayat Pembayaran</h4>
              </div>
              <div className="p-4">
                {(() => {
                  // Hitung data dari pembayaranList
                  const pembayaranData = pembayaranList || [];
                  
                  // Hitung total pembayaran
                  const totalDibayar = pembayaranData.reduce((sum, p) => {
                    const nominal = p.nominal || p.amount || p.jumlah || 0;
                    const nominalNumber = typeof nominal === 'number' ? nominal : parseFloat(nominal) || 0;
                    return sum + nominalNumber;
                  }, 0);
                  
                  // Hitung harga beli dari produk
                  const hargaBeli = produkDetail?.harga_beli || produkDetail?.price || produkDetail?.harga || 0;
                  const hargaBeliNumber = typeof hargaBeli === 'number' ? hargaBeli : parseFloat(hargaBeli) || 0;
                  
                  // Hitung sisa pembayaran
                  const sisaPembayaran = Math.max(0, hargaBeliNumber - totalDibayar);
                  
                  // Hitung progress percentage
                  const progressPercentage = hargaBeliNumber > 0 
                    ? Math.min(Math.round((totalDibayar / hargaBeliNumber) * 100), 100)
                    : 0;
                  
                  // Hitung jumlah bulan yang sudah dibayar (asumsi 1 pembayaran = 1 bulan)
                  const jumlahBulanBayar = pembayaranData.length;
                  
                  // Total tenor default 12 bulan
                  const totalTenor = 12;
                  const sisaTenor = Math.max(0, totalTenor - jumlahBulanBayar);
                  
                  // Tentukan apakah sudah lunas
                  const isLunas = hargaBeliNumber > 0 && totalDibayar >= hargaBeliNumber;
                  
                  // Urutkan pembayaran berdasarkan tanggal (terbaru dulu)
                  const sortedPembayaran = [...pembayaranData].sort((a, b) => {
                    const dateA = new Date(a.tanggal_pembayaran || a.tanggal || a.date || a.created_at || 0);
                    const dateB = new Date(b.tanggal_pembayaran || b.tanggal || b.date || b.created_at || 0);
                    return dateB - dateA;
                  });
                  
                  // Tentukan pembayaran berikutnya
                  let nextPaymentDate = null;
                  let nextPaymentAmount = null;
                  if (!isLunas && sortedPembayaran.length > 0) {
                    // Ambil tanggal pembayaran terakhir
                    const lastPaymentDate = new Date(sortedPembayaran[0].tanggal_pembayaran || sortedPembayaran[0].tanggal || sortedPembayaran[0].date || sortedPembayaran[0].created_at);
                    // Tambah 1 bulan
                    const nextDate = new Date(lastPaymentDate);
                    nextDate.setMonth(nextDate.getMonth() + 1);
                    nextPaymentDate = formatDate(nextDate.toISOString());
                    
                    // Hitung cicilan per bulan (asumsi rata-rata dari pembayaran yang ada)
                    const cicilanAmounts = sortedPembayaran.map(p => {
                      const nominal = p.nominal || p.amount || p.jumlah || 0;
                      return typeof nominal === 'number' ? nominal : parseFloat(nominal) || 0;
                    });
                    if (cicilanAmounts.length > 1) {
                      // Skip pembayaran pertama (biasanya DP lebih besar)
                      const cicilanNormal = cicilanAmounts.slice(1);
                      if (cicilanNormal.length > 0) {
                        const avgCicilan = cicilanNormal.reduce((a, b) => a + b, 0) / cicilanNormal.length;
                        nextPaymentAmount = formatCurrency(avgCicilan);
                      }
                    }
                    if (!nextPaymentAmount) {
                      // Fallback ke cicilan standar
                      nextPaymentAmount = selectedTabungan?.type === 'Tabungan Aqiqah' ? 'Rp 375.000' : 'Rp 300.000';
                    }
                  }
                  
                  return (
                    <>
                      {/* Progress Chart Pembayaran */}
                      <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-4 mb-4">
                        <div className="flex justify-between items-center mb-3">
                          <h6 className="font-semibold text-gray-800">Progress Pembayaran</h6>
                          <span className="text-sm font-bold text-primary">
                            {progressPercentage}% Selesai
                          </span>
                        </div>
                        
                        {/* Progress Bar */}
                        <div className="relative">
                          <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
                            <div 
                              className={`h-4 rounded-full transition-all duration-500 ${
                                isLunas
                                  ? 'bg-gradient-to-r from-blue-500 to-green-500' 
                                  : 'bg-gradient-to-r from-yellow-400 to-orange-500'
                              }`}
                              style={{ 
                                width: `${progressPercentage}%` 
                              }}
                            ></div>
                          </div>
                          
                          {/* Progress Labels */}
                          <div className="flex justify-between text-xs text-gray-600 mb-3">
                            <span>Rp 0</span>
                            <span className="font-semibold">
                              {formatCurrency(totalDibayar)} / {formatCurrency(hargaBeliNumber)}
                            </span>
                            <span>{formatCurrency(hargaBeliNumber)}</span>
                          </div>
                        </div>

                        {/* Stats Grid */}
                        <div className="grid grid-cols-3 gap-3 text-center">
                          <div className="bg-white rounded-lg p-2">
                            <p className="text-xs text-gray-500">Sudah Bayar</p>
                            <p className="font-bold text-green-600 text-sm">
                              {formatCurrency(totalDibayar)}
                            </p>
                          </div>
                          <div className="bg-white rounded-lg p-2">
                            <p className="text-xs text-gray-500">Sisa Pembayaran</p>
                            <p className="font-bold text-orange-600 text-sm">
                              {formatCurrency(sisaPembayaran)}
                            </p>
                          </div>
                          <div className="bg-white rounded-lg p-2">
                            <p className="text-xs text-gray-500">Total Tagihan</p>
                            <p className="font-bold text-primary text-sm">{formatCurrency(hargaBeliNumber)}</p>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-3">
                        {/* Payment List */}
                        {loading ? (
                          <div className="space-y-3">
                            <div className="bg-gray-100 rounded-xl p-4 animate-pulse">
                              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                            </div>
                          </div>
                        ) : sortedPembayaran.length > 0 ? (
                          sortedPembayaran.map((payment, index) => {
                            const nominal = payment.nominal || payment.amount || payment.jumlah || 0;
                            const nominalNumber = typeof nominal === 'number' ? nominal : parseFloat(nominal) || 0;
                            const tanggalPembayaran = payment.tanggal_pembayaran || payment.tanggal || payment.date || payment.created_at || '';
                            const status = payment.status || payment.status_pembayaran || 'Lunas';
                            const metode = payment.metode_pembayaran || payment.payment_method || payment.metode || 'Transfer Bank';
                            
                            const paymentDisplay = {
                              id: payment.id,
                              bulan: formatBulanTahun(tanggalPembayaran),
                              jumlah: formatCurrency(nominalNumber),
                              tanggal: formatDate(tanggalPembayaran),
                              status: getStatusText(status),
                              metode: metode,
                              rawData: payment
                            };
                            
                            return (
                              <div key={payment.id || index} className="bg-gray-50 rounded-xl p-3">
                                <div className="flex justify-between items-start">
                                  <div className="flex-1">
                                    <div className="flex items-center space-x-2 mb-1">
                                      <h6 className="text-sm font-semibold text-gray-800">{paymentDisplay.bulan}</h6>
                                      <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full font-semibold">
                                        {paymentDisplay.status}
                                      </span>
                                    </div>
                                    <p className="text-lg font-bold text-primary">{paymentDisplay.jumlah}</p>
                                    <p className="text-xs text-gray-500">{paymentDisplay.tanggal}</p>
                                    <p className="text-xs text-gray-500">{paymentDisplay.metode}</p>
                                  </div>
                                  <button 
                                    className="text-secondary hover:text-primary transition-colors p-2"
                                    onClick={() => {
                                      setSelectedPayment({
                                        ...paymentDisplay,
                                        id: payment.id || paymentDisplay.id,
                                        rawData: payment
                                      });
                                      setShowPaymentProof(true);
                                    }}
                                  >
                                    <i className="fa-solid fa-chevron-right"></i>
                                  </button>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-gray-50 rounded-xl p-6 text-center">
                            <i className="fa-solid fa-receipt text-4xl text-gray-300 mb-3"></i>
                            <p className="text-gray-500 text-sm">Belum ada riwayat pembayaran</p>
                          </div>
                        )}
                        
                        {/* Total Pembayaran */}
                        <div className="bg-primary rounded-xl p-3 mt-4">
                          <div className="flex justify-between items-center text-white">
                            <span className="font-semibold">Total Dibayar</span>
                            <span className="font-bold text-lg">{formatCurrency(totalDibayar)}</span>
                          </div>
                          <div className="flex justify-between items-center text-white mt-1">
                            <span className="text-sm opacity-80">Sisa Pembayaran</span>
                            <span className="text-sm font-semibold">{formatCurrency(sisaPembayaran)}</span>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>

            {/* Pengiriman Section */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden mt-4">
              <div className="bg-accent p-3">
                <h4 className="text-primary font-bold text-center">Status Pengiriman</h4>
              </div>
              <div className="p-4">
                {loading ? (
                  <div className="space-y-4">
                    <div className="bg-gray-100 rounded-xl p-4 animate-pulse">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>
                ) : (() => {
                  // Ambil pengiriman pertama jika ada
                  const pengiriman = pengirimanList && pengirimanList.length > 0 ? pengirimanList[0] : null;
                  const status = pengiriman?.status || 'pending';
                  const statusLower = status.toLowerCase();
                  
                  // Tentukan status pengiriman
                  const isDelivered = statusLower.includes('delivered') || statusLower.includes('selesai') || statusLower.includes('completed');
                  const isOnProcess = statusLower.includes('process') || statusLower.includes('on_way') || statusLower.includes('dalam_perjalanan');
                  const isPending = !isDelivered && !isOnProcess;

                  if (isDelivered || isOnProcess) {
                    // Pengiriman sudah ada (delivered atau on process)
                    const ekspedisi = pengiriman?.ekspedisi || 'PAK MoO Express';
                    const noResi = pengiriman?.no_resi || '-';
                    const alamatPengiriman = pengiriman?.alamat_pengiriman || 'Alamat belum ditentukan';
                    const deskripsi = pengiriman?.deskripsi || '';
                    const createdAt = pengiriman?.created_at || pengiriman?.tanggal_pengiriman || '';
                    const tanggalKirim = createdAt ? formatDate(createdAt) : '-';
                    const waktuKirim = createdAt ? new Date(createdAt).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }) + ' WIB' : '-';
                    
                    // Get images
                    const buktiImg = pengirimanBuktiImages && pengirimanBuktiImages.length > 0 
                      ? (typeof pengirimanBuktiImages[0] === 'string' 
                          ? getImageUrl(pengirimanBuktiImages[0])
                          : getImageUrl(pengirimanBuktiImages[0].url || pengirimanBuktiImages[0].filename || ''))
                      : (selectedTabungan?.type === 'Tabungan Aqiqah' ? '/sapi2.jpg' : '/sapi1.jpg');
                    
                    const resiImg = pengirimanResiImages && pengirimanResiImages.length > 0
                      ? (typeof pengirimanResiImages[0] === 'string'
                          ? getImageUrl(pengirimanResiImages[0])
                          : getImageUrl(pengirimanResiImages[0].url || pengirimanResiImages[0].filename || ''))
                      : (selectedTabungan?.type === 'Tabungan Aqiqah' ? '/sapi3.jpg' : '/sapi4.jpg');

                    return (
                      <div className="space-y-4">
                        {/* Status Pengiriman */}
                        <div className={`rounded-xl p-4 ${isDelivered ? 'bg-blue-50' : 'bg-orange-50'}`}>
                          <div className="flex items-center space-x-3 mb-3">
                            <div className={`p-2 rounded-full ${isDelivered ? 'bg-blue-500' : 'bg-orange-500'}`}>
                              <i className={`fa-solid ${isDelivered ? 'fa-truck' : 'fa-truck-fast'} text-white`}></i>
                            </div>
                            <div>
                              <h6 className={`font-semibold ${isDelivered ? 'text-blue-800' : 'text-orange-800'}`}>
                                {isDelivered ? 'Pengiriman Selesai' : 'Dalam Perjalanan'}
                              </h6>
                              <p className={`text-sm ${isDelivered ? 'text-blue-600' : 'text-orange-600'}`}>
                                {isDelivered ? 'Sapi telah dikirim ke alamat tujuan' : 'Sapi sedang dalam proses pengiriman'}
                              </p>
                            </div>
                          </div>
                          
                          <div className="grid grid-cols-2 gap-3 text-sm">
                            <div>
                              <span className="text-gray-600">Tanggal Kirim</span>
                              <p className="font-semibold text-gray-800">{tanggalKirim}</p>
                            </div>
                            <div>
                              <span className="text-gray-600">Waktu Kirim</span>
                              <p className="font-semibold text-gray-800">{waktuKirim}</p>
                            </div>
                            <div>
                              <span className="text-gray-600">Kurir</span>
                              <p className="font-semibold text-gray-800">{ekspedisi}</p>
                            </div>
                            <div>
                              <span className="text-gray-600">No. Resi</span>
                              <p className="font-semibold text-gray-800">{noResi}</p>
                            </div>
                          </div>
                        </div>

                        {/* Foto Pengiriman */}
                        {(pengirimanBuktiImages?.length > 0 || pengirimanResiImages?.length > 0) && (
                          <div>
                            <h6 className="text-sm font-semibold text-gray-700 mb-3">Foto Pengiriman</h6>
                            <div className="grid grid-cols-2 gap-3">
                              {pengirimanBuktiImages && pengirimanBuktiImages.length > 0 && (
                                <div className="bg-gray-100 rounded-xl overflow-hidden">
                                  <img 
                                    src={buktiImg}
                                    alt="Foto bukti pengiriman" 
                                    className="w-full h-32 object-cover"
                                    onError={(e) => {
                                      e.target.src = selectedTabungan?.type === 'Tabungan Aqiqah' ? '/sapi2.jpg' : '/sapi1.jpg';
                                    }}
                                  />
                                  <div className="p-2">
                                    <p className="text-xs text-gray-600 text-center">Bukti Pengiriman</p>
                                  </div>
                                </div>
                              )}
                              {pengirimanResiImages && pengirimanResiImages.length > 0 && (
                                <div className="bg-gray-100 rounded-xl overflow-hidden">
                                  <img 
                                    src={resiImg}
                                    alt="Foto resi pengiriman" 
                                    className="w-full h-32 object-cover"
                                    onError={(e) => {
                                      e.target.src = selectedTabungan?.type === 'Tabungan Aqiqah' ? '/sapi3.jpg' : '/sapi4.jpg';
                                    }}
                                  />
                                  <div className="p-2">
                                    <p className="text-xs text-gray-600 text-center">Resi Pengiriman</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Alamat Pengiriman */}
                        {alamatPengiriman && alamatPengiriman !== '-' && alamatPengiriman !== 'Alamat belum ditentukan' && (
                          <div className="bg-gray-50 rounded-xl p-3">
                            <h6 className="text-sm font-semibold text-gray-700 mb-2">Alamat Pengiriman</h6>
                            <p className="text-sm text-gray-600 whitespace-pre-line">{alamatPengiriman}</p>
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    // Belum ada pengiriman atau pending
                    // Tentukan estimasi pengiriman (bisa dari produk atau default)
                    let estimasiPengiriman = 'Desember 2025';
                    if (produkDetail) {
                      // Jika ada produk detail, bisa ambil estimasi dari sana atau hitung berdasarkan tanggal
                      const now = new Date();
                      const estimasiDate = new Date(now);
                      estimasiDate.setMonth(now.getMonth() + 2); // Default 2 bulan dari sekarang
                      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                                     'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
                      estimasiPengiriman = `${months[estimasiDate.getMonth()]} ${estimasiDate.getFullYear()}`;
                    }

                    return (
                      <div className="text-center py-8">
                        <div className="bg-yellow-100 p-4 rounded-xl">
                          <i className="fa-solid fa-clock text-3xl text-yellow-600 mb-3"></i>
                          <h6 className="font-semibold text-yellow-800 mb-2">Menunggu Pengiriman</h6>
                          <p className="text-sm text-yellow-600">
                            Pengiriman akan dilakukan setelah pembayaran selesai
                          </p>
                          <div className="mt-3 text-sm text-yellow-700">
                            <p>Estimasi pengiriman: <strong>{estimasiPengiriman}</strong></p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </section>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  onBack();
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'savings' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => setActiveBottomTab('savings')}
              >
                <i className="fa-solid fa-piggy-bank text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Tabungan</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('products');
                  onBack();
                }}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Produk</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'investment' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('investment');
                  onBack();
                }}
              >
                <i className="fa-solid fa-arrow-trend-up text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Investasi</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  onBack();
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default TabunganQurban;
